
import { Toast, PullRefresh, SwipeCell, Dialog, Badge, Field } from "vant";
Vue.use(Badge);
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  extractInfo,
  extractApply,
  userSign,
  querySvipUserInfo,
} from "@/req/pay";
import ExtactBtn from "./extactBtn.vue";
import SvipPopupInfoModal from "../modal/svipPopupInfoModal.vue";
@Component({
  components: { PullRefresh, SwipeCell, Badge, ExtactBtn, SvipPopupInfoModal },
})
export default class Logout extends Vue {
  @Prop({ default: {}, type: Object }) public extractData;
  @Prop({ default: false, type: Boolean }) public clause;
  @Prop({ default: false, type: Boolean }) public goldSign;

  public btnAcivte = false;
  public alipayAccount = "";
  public explainShow = false;
  public money: any = "";
  public canExtract: any = null;
  public infoList: any = {};
  public type: any = 2;
  public loadingShow = false;
  public svipClause = false;
  public svipLevel = 0;
  public getSvipInfoNum = 0;
  public isTopspeed = false;

  public mounted() {
    this.infoList = this.extractData.infoList;
    this.type = this.extractData.type;
    this.getCanExtract();
    this.syncSvipClause();
    this.getSvipInfo();
  }
  @Watch("extractData", { deep: true })
  public extractDataChange(val) {
    this.infoList = val.infoList;
    this.type = val.type;
    this.getCanExtract();
    this.syncSvipClause();
  }
  public syncSvipClause() {
    const hasDiscount =
      this.type == 2 &&
      this.infoList.coupon_can_use_money > 0 &&
      Number(this.infoList.svip_value_use_limit_pct) > 0;
    this.svipClause = hasDiscount;
  }
  public getCanExtract() {
    this.canExtract =
      this.type == 1
        ? this.$store.state.user.info.gold
        : this.$fn.byHundred(this.infoList.trade_coin);
  }
  // 提现
  public onExtract() {
    this.efficacy();
  }
  // 极速提现
  public onTopspeed() {
    this.efficacy(true);
  }
  // 全部提现
  public allWithdrawal() {
    if (this.canExtract <= 0) return Toast("无可提现金额");
    if (this.type == 1) {
      if (this.canExtract < 100) return (this.money = 0);
      this.money = Math.floor(this.canExtract / 100);
      return;
    }
    if (this.canExtract > 100000) {
      this.money = 100000;
    } else {
      this.money = Math.floor(this.canExtract);
    }
    this.efficacy();
  }
  // 效验
  public async efficacy(speedType?: boolean) {
    const min = this.infoList.minExtractMoney;
    let extractMoney = this.money;
    this.isTopspeed = speedType ? true : false;
    if (Number(this.type) === 1) {
      const page: any = (window as any).newExtractPage;
      if (page && typeof page.checkFaceSign === "function") {
        const canExtract = await page.checkFaceSign();
        if (!canExtract) return;
      }
    }
    if (this.type == 1) extractMoney = extractMoney * 100;
    if (this.infoList.is_no_audit == 1) return;
    if (this.alipayAccount == "") return Toast("支付宝账号不能为空");
    if (!this.clause) return Toast("请勾选下方合作协议");
    if (this.money == "") return Toast("提现金额不能为空");
    if (this.money < min) return Toast(`最低提现金额${min}元`);
    if (this.money > this.canExtract) return Toast("超出最大可提现金额");
    if (speedType) {
      const hitData = {
        title1: "您本月可极速提现的额度",
        title2: `剩余${this.infoList.speed_up_total_surplus / 100}元`,
      };
      if (extractMoney > this.infoList.speed_up_total_surplus / 100) {
        return this.$emit("quotaShow", hitData);
      }
      if (extractMoney > this.infoList.speed_up_day_surplus / 100) {
        hitData.title1 = "您今日可极速提现的额度";
        hitData.title2 = `剩余${this.infoList.speed_up_day_surplus / 100}元`;
        return this.$emit("quotaShow", hitData);
      }
    }
    this.$emit("efficacyNum", this.money);
  }
  public secondEfficacy() {
    if (!this.goldSign && this.type == 1) {
      this.loadingShow = true;
      this.onUserSign();
      return;
    }
    this.modalShow(1, this.isTopspeed);
  }
  // 调用父盒子提现方法
  public modalShow(id, speedType) {
    const obj = {
      id,
      money: this.money,
      account: this.alipayAccount,
      svipClause: this.svipClause,
      speedType,
    };
    this.$emit("modalShow", obj);
  }
  public onInput(value) {
    if (value > 100000) {
      this.money = 100000;
    } else {
      this.money = value;
    }
    if (value.length == 0) {
      this.btnAcivte = false;
    } else {
      this.btnAcivte = true;
    }
  }

  // 金币提现签约查询接口
  public async onUserSign() {
    try {
      const res = await userSign({
        token: this.$fn.cookies.getToken(),
      });
      if (res.code == 200) {
        this.goldSign = true;
        this.$emit("update:goldSign", true);
        this.modalShow(1, false);
      } else {
        Toast(res.msg);
      }
    } finally {
      this.loadingShow = false;
    }
  }

  public async getSvipInfo() {
    if (!this.$store.state.user.info.id) {
      this.getSvipInfoNum = this.getSvipInfoNum + 1;
      if (this.getSvipInfoNum > 3) return;
      const thah = this;
      setTimeout(() => {
        thah.getSvipInfo();
      }, 1000);
      return;
    }
    const res = await querySvipUserInfo({
      userId: this.$store.state.user.info.id,
    });
    if (res.code == 200) {
      this.svipLevel = res.data.svipLevel;
    }
  }
  // 手续费计算
  public getServiceCharge() {
    if (!this.money) return 0;
    const ratio = Number(this.infoList.minExtarctRatio) || 0;
    let num = (this.money * ratio) / 100;
    const minNum = Number(this.infoList.minExtarctCharge) || 0;
    num = num > minNum ? num : minNum;
    const svipPct = Number(this.infoList.svip_value_use_limit_pct);
    if (
      this.svipClause &&
      this.infoList.coupon_can_use_money > 0 &&
      svipPct > 0
    ) {
      // 得出减免后的 提现所付手续费
      let limitPct = (num * svipPct) / 100;
      num = num - limitPct;
      const maxDeductMoney = this.infoList.coupon_can_use_money / 100;
      limitPct =
        limitPct - maxDeductMoney > 0 ? limitPct - maxDeductMoney : 0;
      num = num + limitPct;
    }
    return num ? num.toFixed(2) : 0;
  }
  // 当前减免额度计算
  public getCanUseMoney() {
    if (!this.money) return 0;
    const svipPct = Number(this.infoList.svip_value_use_limit_pct);
    if (!this.infoList.coupon_can_use_money || svipPct <= 0) return 0;
    const minNum = Number(this.infoList.minExtarctCharge) || 0;
    const ratio = Number(this.infoList.minExtarctRatio) || 0;
    let currentNum = (this.money * ratio) / 100;
    currentNum = currentNum < minNum ? minNum : currentNum;
    currentNum = (currentNum * svipPct) / 100;
    const maxDeductMoney = this.infoList.coupon_can_use_money / 100;
    const num = currentNum >= maxDeductMoney ? maxDeductMoney : currentNum;
    return "-" + (num ? num.toFixed(2) : 0);
  }
  public svipClauseChange(e) {
    this.getServiceCharge();
    this.getCanUseMoney();
  }
  public viewAccountTime() {
    (window as any).sendViewAccountTime();
  }
}
